@let returnButtonText =
  isClerk() ? 'Return to search' : 'Return to Applications';
<section class="flex gap-x-2 items-center">
  <ui-button class="w-max" appReturnToSearch>
    @if (isClerk()) {
      <fa-icon [icon]="faSearch" class="mr-1" />
    }
    {{ returnButtonText }}
  </ui-button>
  <button
    class="flex gap-x-1 cursor-pointer hover:bg-neutral-100 px-2 py-1 rounded-md font-medium text-neutral-950"
    (click)="logout()">
    <fa-icon [icon]="faRightFromBracket" />
    Logout
  </button>
</section>
